import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "list-filter" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("label", null, "Filter", -1)
const _hoisted_3 = ["value"]

import { computed } from 'vue';
import { useStore } from 'vuex';
import { Mutations } from '@/store';


export default /*#__PURE__*/_defineComponent({
  __name: 'ListFilter',
  setup(__props) {

const store = useStore();

const filter = computed(() => store.state.filter);

const updateFilter = (evt: Event) => {
  store.commit(Mutations.SetFilter, (<HTMLInputElement>evt.target)!.value);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("input", {
      type: "text",
      value: _unref(filter),
      onInput: updateFilter
    }, null, 40, _hoisted_3)
  ]))
}
}

})